import { inject, Injectable } from '@angular/core';
import { AmplitudeService } from '@brighthub/logging';

/** PPI-safe analytics for FA actions in the credit overview. */
@Injectable({ providedIn: 'root' })
export class CreditOverviewAnalytics {
  private readonly _amplitude = inject(AmplitudeService);

  linkSent(): void {
    this._amplitude.logEvent('credit_link_sent', {
      app: 'brightnav',
    });
  }
}
